module.exports = __webpack_public_path__ + "static/media/video-realistic.2a504478.png";